import EditAddress from "../../Common/editAddress.vue";
import Multiselect from "vue-multiselect";
import { required, minLength, maxLength } from 'vuelidate/lib/validators';

export default {
    name: "ClientEditAddress",
    extends: EditAddress,

    components: { Multiselect },
    computed: {
        countyIsInvalid() {
            // Here we have access to $v to check if its dirty, but not really helpful.
            // The error should be displayed when the user tries to SUBMIT (the data should come from other data flux)
            return this.$v.address.County.$dirty && this.address.County == null;
        },
        townIsInvalid() {
            // SAME above
            return this.$v.address.SIRUTA.$dirty && this.address.SIRUTA == null;
        }
    },
    created() {
        console.log(this.address.zipCode);
    },
    methods: {
        markAsTouched: function(val) {
            const field = this.getDescendantProp(this.$v, val);
            field && field.$touch();
        },
        chkState: function(val) {
            const field = this.getDescendantProp(this.$v, val);

            !field && console.log(`Nu exista ${val}`);

            return field && field.$dirty ? !field.$error : null;
        }
    },

    //validations: {
    //    address: {
    //        County: {
    //            required
    //        },
    //        SIRUTA: {
    //            required
    //        },
    //        Street: {
    //            required
    //        },
    //        No: {
    //            required
    //        },
    //        Bloc: {
    //            //required
    //        },
    //        Staircase: {
    //            //required
    //        },
    //        Floor: {
    //            //required
    //        },
    //        Apartment: {
    //            //required
    //        },
    //        ZipCode: {
    //            required,
    //            minLength: minLength(6),
    //            maxLength: maxLength(6)
    //        }
    //    },
    //},
};
